import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Spinner, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { selectPreviewModal, selectPreviewModalLoader } from '../../../../redux/modules/emails';
import PreviewRow from '../PreviewRow';

const PreviewModal = ({ recipientTitle = 'Insureds' }) => {
  const previewModal = useSelector(selectPreviewModal);
  const isLoading = useSelector(selectPreviewModalLoader);

  const newDate = new Date(Date.now());

  if (isLoading) {
    return (
      <Box textAlign="center">
        <Text as="h3">Loading...</Text>
        <br />
        <Spinner
          color="primaryScale.600"
          emptyColor="gray.200"
          size="xl"
          speed="0.65s"
          thickness="4px"
        />
      </Box>
    );
  }

  const toRecipients = previewModal?.recipients?.length ? previewModal.recipients?.join(', ') : previewModal.email;

  return (
    <Box>
      <PreviewRow html={newDate.toDateString()} title="Date" />
      <PreviewRow html={toRecipients} title={recipientTitle} />
      { previewModal.emailCc ? <PreviewRow html={previewModal.emailCc} title="Cc" /> : null }
      <PreviewRow html={previewModal.subjectHtml} title="Subject" />
      <PreviewRow html={previewModal.bodyHtml} title="Message" />
    </Box>
  );
};

PreviewModal.propTypes = { recipientTitle: PropTypes.string };

export default PreviewModal;
